<div *ngIf="hbaProfileDataSettings.MemberTypeCode.Visible">
  <label class="control-label">{{ hbaProfileDataSettings.MemberTypeCode.LabelText }}</label>
  <select class="form-control"></select>
</div>

<div *ngIf="hbaProfileDataSettings.MembershipStatusCode.Visible">
  <label class="control-label">{{ hbaProfileDataSettings.MembershipStatusCode.LabelText }}</label>
  <select class="form-control"></select>
</div>

<div *ngIf="hbaProfileDataSettings.NumberOfUnitsCode.Visible">
  <label class="control-label">{{ hbaProfileDataSettings.NumberOfUnitsCode.LabelText }}</label>
  <select class="form-control"></select>
</div>

<div *ngIf="hbaProfileDataSettings.DollarVolumeCode.Visible">
  <label class="control-label">{{ hbaProfileDataSettings.DollarVolumeCode.LabelText }}</label>
  <select class="form-control"></select>
</div>

<div *ngIf="hbaProfileDataSettings.PrimaryBusActivityCode.Visible">
  <label class="control-label">{{ hbaProfileDataSettings.PrimaryBusActivityCode.LabelText }}</label>
  <select class="form-control"></select>
</div>

<div *ngIf="hbaProfileDataSettings.SecondaryBusActivityCode.Visible">
  <label class="control-label">{{ hbaProfileDataSettings.SecondaryBusActivityCode.LabelText }}</label>
  <select class="form-control"></select>
</div>

<div *ngIf="hbaProfileDataSettings.TertiaryBusActivityCode.Visible">
  <label class="control-label">{{ hbaProfileDataSettings.TertiaryBusActivityCode.LabelText }}</label>
  <select class="form-control"></select>
</div>
